/**
 * Job Description types for ATS.
 */

export type JDProcessingStatus = 'pending' | 'processing' | 'processed' | 'error';

export interface JobDescription {
  id: string;
  job_id: string;
  job_name: string | null;
  name: string;
  file_url: string | null;
  file_name: string | null;
  file_type: string | null;
  file_size: number | null;
  processing_status: JDProcessingStatus;
  raw_content: string | null;
  parsed_data: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export interface JobDescriptionListResponse {
  items: JobDescription[];
  total: number;
}

export interface JobDescriptionUploadInput {
  name?: string;
  file?: File;
  raw_content?: string;
}

export interface JobDescriptionUpdateInput {
  name?: string;
  file_url?: string;
  raw_content?: string;
  parsed_data?: Record<string, unknown>;
}

export const JD_PROCESSING_STATUS_CONFIG: Record<
  JDProcessingStatus,
  { label: string; color: 'yellow' | 'blue' | 'green' | 'red' }
> = {
  pending: { label: 'Pending', color: 'yellow' },
  processing: { label: 'Processing', color: 'blue' },
  processed: { label: 'Processed', color: 'green' },
  error: { label: 'Error', color: 'red' },
};
